import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const User = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 5C14.4772 5 10 9.47715 10 15C10 20.5228 14.4772 25 20 25C25.5229 25 30 20.5228 30 15C30 9.47715 25.5229 5 20 5ZM8.00001 15C8.00001 8.37258 13.3726 3 20 3C26.6274 3 32 8.37258 32 15C32 20.2994 28.5648 24.7965 23.7997 26.386C29.7689 27.6278 34.2872 31.7204 36.88 36.5251C37.1423 37.0111 36.9609 37.6177 36.4749 37.88C35.9889 38.1423 35.3823 37.9609 35.12 37.4749C32.2709 32.1954 26.9702 28 20 28C13.0298 28 7.72914 32.1954 4.88004 37.4749C4.61776 37.9609 4.01113 38.1423 3.5251 37.88C3.03907 37.6177 2.85769 37.0111 3.11998 36.5251C5.71281 31.7204 10.2312 27.6278 16.2003 26.386C11.4352 24.7965 8.00001 20.2994 8.00001 15Z" fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default User;
